var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15989",
    "data-name": "Group 15989",
    transform: "translate(-313.438 -846.438)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(313.438 846.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(329.457 858.605) rotate(11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14617",
    "data-name": "Group 14617",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57111",
    "data-name": "Path 57111",
    d: "M31.088.269a.919.919,0,0,0-.991-.2L.577,11.873a.919.919,0,0,0-.06,1.68L12.158,19.2,17.8,30.839a.919.919,0,0,0,.826.518h.033a.919.919,0,0,0,.82-.577L31.291,1.26A.919.919,0,0,0,31.088.269ZM3.19,12.807,26.624,3.434,12.658,17.4ZM18.55,28.166,13.958,18.7,27.923,4.733Z",
    fill: "#444"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.062e723572131d321d8b39081b72eb66.svg";
export { ForwardRef as ReactComponent };